import { graphql } from '../../../../graphql/generated';

export const UPDATE_ANALYSIS_STATION_MUTATION = graphql(`
  mutation UpdateAnalysisStation($id: ID!, $input: AnalysisStationUpdateInput!) {
    updateAnalysisStation(id: $id, input: $input) {
      id
    }
  }
`);
